// routes
import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';
import { NavItemProps } from './nav/types';
// import TopupArrow from 'src/assets/illustrations-staxter/topupArrow';

// ----------------------------------------------------------------------

const navLogoStyle = {
  width: 22,
};

// ----------------------------------------------------------------------

export const navConfig: NavItemProps[] = [
  // {
  //   title: 'Cart',
  //   showTitle: { onDesktop: false, onMobile: true },
  //   icon: (
  //     <Cart sx={{ ...navLogoStyle, filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));' }} />
  //   ),
  //   path: paths.cart.root,
  //   showIcon: { onDesktop: true, onMobile: true },
  // },
  {
    title: 'Products',
    showTitle: { onDesktop: true, onMobile: true },
    showIcon: { onDesktop: false, onMobile: false },
    // path: paths.root,
    children: [
      {
        title: 'Pathen',
        showTitle: { onDesktop: true, onMobile: true },
        path: paths.pathen,
        showIcon: { onDesktop: false, onMobile: false },
      },
    ],
  },
  {
    title: 'Services',
    showTitle: { onDesktop: true, onMobile: true },
    path: `#services`,
    showIcon: { onDesktop: false, onMobile: false },
  },
  {
    title: 'Team',
    showTitle: { onDesktop: true, onMobile: true },
    path: '#team',
    showIcon: { onDesktop: false, onMobile: false },
  },
  {
    title: 'About us',
    showTitle: { onDesktop: true, onMobile: true },
    path: '#about',
    showIcon: { onDesktop: false, onMobile: false },
  },
];
